module.exports = __webpack_public_path__ + "static/media/spacen-man.ab440d0f.svg";